import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import { getField, updateField } from 'vuex-map-fields';

/**
 * Setting axios base URL.
 */
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
const token = process.env.VUE_APP_GATEKEEPER_KEY;

Vue.use(Vuex);

const errorOnSearch = ({ commit }, err) => {
  console.warn(err);
  if (err.response) {
    if (err.response.status === 404) {
      let saveMessage = function(err) {
        return typeof err.response.data.message != 'undefined' ? err.response.data.message :
          typeof err.response.data.lastUpdated != 'undefined' ? err.response.data.lastUpdated : "";
      };
      typeof err.response.data != 'undefined' ? commit('setMessage', saveMessage(err)) : "";
    }
    return false;
  }
  return new Error(`System is down`);
};

function clearData() {
  return  {
    "PID": "",
    "FirstName": "",
    "LastName": "",
    "birthdate": "",
  };
}

export default new Vuex.Store({
  state: {
    searchResults: [],
    searchData: clearData(),
    displayLayout: "",
    message: "",
    languages: [
      { language: 'en', title: 'English' },
      { language: 'es', title: 'Español' },
    ],
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,
    clearData(state) {
      state.searchData = clearData();
    },
    setDisplay(state, displayType) {
      state.displayLayout = displayType;
    },
    setLanguage(state, lang) {
      state.curLanguage = lang;
    },
    setMessage(state, message) {
      state.message = message;
    },
    setResultData(state, data) {
      if (!Array.isArray(data)) {
        data = [ data ];
      }
      state.searchResults = data;
    },
  },

  actions: {
    async getStatus({ commit }) {
      try {
        const { data } = await axios.get(`health-check`,{ params: { gatekeeperKey: token }});
        let status = [ "healthy" ].includes(data.message) ? "form" : "error";
        if (status === 'error') {
          console.log(this.$router);
          if (this.$router.history.current.name !== 'system-down') {
            this.$router.push({ name: 'system-down' });
          }
        } else {
          if (this.$router.history.current.name !== 'home') {
            this.$router.push({ name: 'home' });
          }
        }
      } catch (err) {
        console.log(this.$router);
        if (this.$router.history.current.name !== 'system-down') {
          this.$router.push({ name: 'system-down' });
        }
      }
    },
    async getDataByName({ commit }, searchPayload) {
      delete searchPayload.PID;
      commit('setResultData', []);
      try {
        console.log(searchPayload);
        const { data } = await axios.get('inmates/', { params: { ...searchPayload, gatekeeperKey: token }});
        commit('setResultData', data);
        return true;
      } catch (err) {
        return errorOnSearch({ commit }, err);
      }
    },
    async getDataByPID({ commit }, PID) {
      // console.log("get data by PID");
      commit('setResultData', []);
      try {
        // console.log("PID", PID);
        const { data } = await axios.get(`inmates/${PID}`, { params: { gatekeeperKey: token }}, { responseType: 'text' });
        commit('setResultData', data);
        // console.log( "returning true");
        return true;
      } catch (err) {
        return errorOnSearch({ commit }, err);
      }
    },
  },
});
